import { Injectable, Inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiChopin, API_CHOPIN } from '../config/index';
import { Observable } from 'rxjs';
import {
  FavouriteMetadata,
  Pagination,
  Performance,
  PerformanceCategory,
  PerformanceMetadata,
  PerformanceRecentlyPlayed,
  PerformanceRecentlyPlayedRequestParams,
  PerformanceRequestParams,
} from '@shared/interfaces';
import { map, mapTo } from 'rxjs/operators';

@Injectable()
export class PerformancesService {
  constructor(
    @Inject(API_CHOPIN) private api: ApiChopin,
    private http: HttpClient
  ) {}

  getAll(
    params?: PerformanceRequestParams
  ): Observable<Pagination<Performance>> {
    return this.http.get<Pagination<Performance>>(this.api.PERFORMANCE(), {
      params: params as any,
    });
  }

  get(id: number): Observable<Performance> {
    return this.http.get<Performance>(this.api.PERFORMANCE(id))
  }

  getRecomended(
    params?: PerformanceRequestParams
  ): Observable<Pagination<Performance>> {
    return this.http.get<Pagination<Performance>>(
      this.api.PERFORMANCE_CHOSEN_FOR_USER(),
      { params: params as any }
    );
  }

  getRecentlyPlayedAll(
    params?: PerformanceRecentlyPlayedRequestParams
  ): Observable<Pagination<PerformanceRecentlyPlayed>> {
    return this.http.get<Pagination<PerformanceRecentlyPlayed>>(
      this.api.RECENTLY_PLAYED(),
      { params: params as any }
    );
  }

  setRecentlyPlayed(performanceId: number): Observable<void> {
    return this.http.post<void>(this.api.RECENTLY_PLAYED(), {
      performance: performanceId,
    });
  }

  setFavourite(id: number): Observable<boolean> {
    return this.http
      .post(this.api.PERFORMANCE_FAVORITE(), { performance: id })
      .pipe(mapTo(true));
  }

  unsetFavourite(id: number): Observable<boolean> {
    return this.http
      .delete(this.api.PERFORMANCE_FAVORITE(id))
      .pipe(mapTo(true));
  }

  getFavoritePerformanceMetadata(): Observable<FavouriteMetadata> {
    return this.http.get<FavouriteMetadata>(
      this.api.PERFORMANCE_FAVORITE_META()
    );
  }

  getPerformanceMetadata(params?: PerformanceRequestParams): Observable<PerformanceMetadata> {
    return this.http.get<PerformanceMetadata>(
      this.api.PERFORMANCE_META(),
      { params: params as any }
    );
  }

  getPerformanceCategorie(params?: PerformanceRequestParams): Observable<PerformanceCategory[]>{
    return this.http.get<Pagination<PerformanceCategory>>(
      this.api.PERFORMANCE_CATEGORIES(),
      { params: params as any }
    ).pipe(map(data => data.items));
  }

}
